interface AppScreenshotsProps {
  title: string;
  subtitle: string;
  items: Array<{ id: string; image: string; caption: string }>;
}

export function AppScreenshots({ title, subtitle, items }: AppScreenshotsProps) {
  return (
    <section className="py-24">
      <div className="px-4 md:px-6 text-center mb-12">
        <h2 className="text-3xl font-bold mb-4">{title}</h2>
        <p className="text-muted-foreground">{subtitle}</p>
      </div>

      <div className="flex justify-center gap-4 md:gap-6 px-4 md:px-6 flex-wrap">
        {items.map((item) => (
          <div key={item.id} className="flex-shrink-0">
            <div className="rounded-2xl shadow-lg overflow-hidden border border-border/50 mb-3">
              <img
                src={item.image}
                alt={item.caption}
                className="object-contain h-[400px] md:h-[500px]"
              />
            </div>
            <p className="text-sm text-muted-foreground text-center">{item.caption}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
